/**
 * ============================================================================
 *  SITE_EDITION — 前端侧的部署级版本开关
 * ============================================================================
 *
 * 由 `REACT_APP_SITE_EDITION` 在**构建期**注入（deploy/clients/*.conf 里配）。
 * 不设 = 'commercial'，即商业版行为，和这个开关引入前完全一致。
 *
 * 版本标识：
 *   - commercial: Cineart Canvas 商业版（主站）
 *   - edu: Cineart Canvas 教育版
 *   - huanshe-edu: 环艺学姐教育版
 *   - huanshe-commercial: 环艺学姐商业版
 *
 * ⚠️ 为什么这里写成 `process.env.X === 'edu'` 而不是先取出来再比较：
 *    CRA 会把 `process.env.REACT_APP_SITE_EDITION` **原地替换成字符串字面量**，
 *    所以这一行在商业版构建里就是 `"commercial" === "edu"` → terser 直接折成 false，
 *    引用它的 `{IS_EDU && <付费入口/>}` 整块被当死代码删掉。
 *    若写成 `(process.env.X || 'commercial').toLowerCase() === 'edu'`，
 *    折叠就要指望 terser 对 `.toLowerCase()` 求值，没保证 —— 别改成那样。
 *
 * ⚠️ 但**只靠这个开关不够**：`import RechargeModal from './RechargeModal'` 是静态导入，
 *    就算调用点被删了，模块内容（「充值」「虎皮椒」「¥」）照样进 bundle。
 *    所以教育版构建时还会把 RechargeModal.js 换成 RechargeModal.edu-stub.js，
 *    见 deploy/deploy-client.sh 的 override_edition()。
 */

const SITE_EDITION = process.env.REACT_APP_SITE_EDITION || 'commercial';

/** 判断是否为教育版（无支付、MinIO、仅境内厂商） */
export const IS_EDU = SITE_EDITION === 'edu' || SITE_EDITION.endsWith('-edu');

/** 商业版 = 非教育版。写成显式常量，读代码时不用反着想。 */
export const IS_COMMERCIAL = !IS_EDU;

/** 判断是否为环艺学姐站点 */
export const IS_HUANSHE = SITE_EDITION.startsWith('huanshe');

/** 判断是否启用支付功能（编译时决定） */
export const HAS_PAYMENT = process.env.REACT_APP_ENABLE_PAYMENT === 'true';

/** 获取站点版本标识 */
export const SITE_EDITION_NAME = SITE_EDITION;

/**
 * 后台「管理员给用户加积分」这个动作的措辞。
 *
 * 它本身跟钱无关（超管无中生有 / 普管从自己余额转），但**「充值」两个字**
 * 在合规扫描眼里就是收费信号。教育版整站不能出现付费暗示，为了不让人工复核
 * 卡在一个假阳性上，edu 下统一改口叫「发放」（也和阶段 4 的算力券对得上）。
 *
 * ⚠️ 必须用 process.env 直接比较，不能用 IS_EDU 变量：
 *    IS_EDU 是运行时计算的 → terser 不敢优化 → 两个字符串都进 bundle。
 *    process.env.X 是编译期字面量替换 → 死分支直接删掉 → 教育版产物里没有「充值」。
 */
export const CHARGE_WORD = (process.env.REACT_APP_SITE_EDITION === 'edu' ||
                             (process.env.REACT_APP_SITE_EDITION || '').endsWith('-edu'))
  ? '发放'
  : '充值';

/** 站点显示名称（运行时从后端 API 获取，这里只是兜底） */
export const SITE_NAME_FALLBACK = IS_HUANSHE ? '环艺学姐' : 'Cineart Canvas';
